import React, { useEffect, useState } from "react";
import "./Process.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLanguage } from "../LanguageContext";

const contentData = {
  english: {
    productsTitle: "",
    headingLine1: "In the Development of Piplav village",
    headingLine2: "A Story Of Cooperation and Dedication",
    description:
      "Farmers, projects, development, cooperation, self-reliance, technology, electricity, institutions, agriculture, animal husbandry, prosperity, industry, export, planning, and policy.",
    buttonText: "Learn More",
    slides: [
      {
        number: "01",
        title: "Inspiration for Village Improvement and Modernization",
        subtitle: "",
        description: [
          "Bringing transformation to farmers' lives and providing urban-level amenities in villages, Tejash Patel represents farmers across 13 organizations.",
          "",
          '"If anyone deserves to walk proudly on this earth, it is the farmer." - Sardar Patel',
          "",
          "The Charotar region is rich in agriculture and animal husbandry. From this cooperative movement, Amul emerged, standing as a beacon of collective strength. Charotar residents have not only influenced Gujarat but have made a mark globally with their entrepreneurship.",
          "",
          "Following the path of Tribhuvandas Patel, who spearheaded development through cooperation, Tejash Patel has become a source of inspiration for village improvement and modernization. He works relentlessly on genuine development projects and acts as a representative of farmers through cooperation, entrepreneurship, and a spirit of service. His unique vision and efforts are bringing remarkable change to rural areas.",
        ],
      },
      {
        number: "02",
        title:
          "Fourth Generation Dedication of a Farming Family for Rural Development",
        subtitle: "",
        description: [
          "Despite the ability to live comfortably abroad, the Patidars of Charotar remained committed to their villages and farmer welfare. After the untimely demise of their father, Sandeep and Tejash Patel took responsibility and started working for the farmers' benefit.",
          "",
          "In 1999, Tejash Patel won the Petlad-Sojitra Taluka Purchase-Sale Union elections, improved its management, started a Farmer Help Center at Petlad APMC, and introduced the 'Apni Mandi' concept. As a Director at Amul Dairy, he worked continuously for the welfare of milk producers.",
          "",
          "In 2018, Tejash Patel founded a Solar Energy Cooperative Society, enabling 388 farmers to produce 30 million units of electricity. He also initiated biogas and organic fertilizer projects to promote village self-reliance. Under the Orange Revolution, efforts toward establishing solar cooperatives and providing 25 years of free electricity are ongoing. Through new projects and schemes, he strives to bring permanent change for farmers.",
        ],
      },
      {
        number: "03",
        title: "Manibhai Patel’s Journey Advancing Cooperative Activities",
        subtitle: "",
        description: [
          "Collaborating with Tribhuvandas Patel, a pioneer of the White Revolution, Manibhai Patel laid the foundation for cooperative movements in villages. Besides establishing a milk cooperative in Piplav, he helped start cooperatives in nearby villages too. As the village Sarpanch (head), he undertook numerous development initiatives.",
          "",
          "“To accommodate pilgrims visiting the Ashapuri Mata Temple from across the country, a modern bus station was built in Piplav village in 1975.”",
          "",
          "The Ashapuri Mata Temple in Piplav became a spiritual center, attracting visitors from across India. To serve these pilgrims, land was allocated for a bus station, and by 1975, a fully equipped, modern bus station—the first of its kind in the large Kheda district—was established. From 1961 to 1975, he initiated several projects to elevate the living standards of farmers in Piplav and surrounding villages.",
        ],
      },
      {
        number: "04",
        title:
          "Bipinbhai Patel Continuing on New Paths of Cooperative Activities",
        subtitle: "",
        description: [
          "Bipinbhai Patel represented farmers across various government bodies and organizations. He contributed greatly to the development of the Ashapuri Mata Temple and served as a trustee. As Sarpanch, he developed gardens and playgrounds, allotted land for laborers' housing, and built homes through government schemes.",
          "",
          "He also contested the Legislative Assembly elections alongside Indubhai Chaturbhai Patel and served as a Petlad Taluka Panchayat Member for 35 years. As Chairman of the Petlad-Sojitra Taluka Purchase-Sale Union, he ensured necessary supplies reached farmers affordably.",
          "",
          "He served lifelong as President of the Piplav Kelavani Mandal and the Patidar community. His father, Minbhai Patel, was a founder-director of cooperative societies since 1950. Bipinbhai devoted his entire life to farmer welfare and empowerment.",
        ],
      },
      {
        number: "05",
        title:
          "Tejash Patel and Sandeep Patel’s Mission to Make Villages Self-Reliant",
        subtitle: "",
        description: [
          "Though Charotar’s Patidars could live happily abroad, they remained committed to village development. After the unexpected demise of Bipinbhai Patel, his sons, Sandeep and Tejash Patel, carried forward his legacy, working for farmers' welfare.",
          "",
          "Sandeep Patel was elected as Sojitra Taluka Panchayat President in 2000, leading several housing and development projects. In 1999, Tejash Patel became a director of the Petlad-Sojitra Purchase-Sale Union and utilized technology to distribute 8000 goods at lower costs to farmers. He introduced the ‘Apni Mandi’ concept at APMC and held key positions in Amul Dairy and GUJCOMASOL.",
          "",
          "In 2018, they founded a Solar Energy Cooperative Society, through which 388 farmers produced 30 million units of electricity. Through clean energy projects, biogas, and the Orange Revolution initiatives, they are making villages self-reliant and ensuring government schemes reach the farmers effectively.",
        ],
      },
    ],
  },

  gujarati: {
    productsTitle: "",
    headingLine1: "પીપળાવ ગામના વિકાસમાં",
    headingLine2: "સહકાર અને સમર્પણની ગાથા",
    description:
      "ખેડૂતો, પ્રોજેક્ટ, વિકાસ, સહકાર, આત્મનિર્ભરતા, ટેક્નોલોજી, વીજળી, સંસ્થાઓ, કૃષિ, પશુપાલન, સમૃદ્ધિ, ઉદ્યોગ, નિકાસ, આયોજન, અને નીતિ.",
    buttonText: "Learn More",
    slides: [
      {
        number: "01",
        title: "ગ્રામ સુધારણા અને ગ્રામ આધુનિકરણના પ્રેરણાસ્ત્રોત",
        subtitle: "",
        description: [
          "ખેડૂતોના જીવનમાં પરિવર્તન લાવી ગામડાઓમાં શહેર જેવી સુવિધાઓ ઉપલબ્ધ કરાવવા તેજશ પટેલ 13 સંસ્થાઓમાં ખેડૂતોનું પ્રતિનિધિત્વ કરે છે.",
          "",
          '"આ ધરતી ઉપર છાતી કાઢીને ચાલવાનો અધિકાર હોય તો તે માત્ર ખેડૂતને જ છે." - સરદાર પટેલ',
          "",
          "ચરોતર પ્રદેશ કૃષિ અને પશુપાલનમાં સમૃદ્ધ છે. સહકારી આંદોલનથી અમૂલનો ઉદય થયો, જે લોકસહકારની શાન છે. ચરોતરવાસીઓએ ગુજરાત જ નહીં, પણ વિદેશમાં પણ પ્રભાવ પાડી પોતાની સાહસિકતા સાબિત કરી છે.",
          "",
          "ત્રિભુવનદાસ પટેલે સહકારના માધ્યમથી વિકાસ ચીંધ્યો. તેમનાં પગલે તેજશ પટેલ ગ્રામ સુધારણા અને આધુનિકરણ માટે પ્રેરણાસ્ત્રોત બન્યા. તેઓ તદ્દન વિકાસ પ્રોજેક્ટ પર કાર્યરત છે.તેજશ પટેલ સહકારિતા, સાહસિકતા અને સેવાભાવે ખેડૂતોના પ્રતિનિધિ તરીકે કાર્યરત છે. તેમની આગવી દ્રષ્ટિ અને પ્રયત્નોથી ગામડાઓમાં પરિવર્તન આવી રહ્યું છે.",
        ],
      },
      {
        number: "02",
        title:
          "ગામ્રીણ વિકાસ માટે પીપળાવના ખેડૂત પરિવારની ચોથી પેઢીનું જીવન સમર્પણ",
        subtitle: "",
        description: [
          "ચરોતરના પાટીદારો વિદેશમાં સુખી જીવન જીવી શકતા હોવા છતાં, તેઓ પોતાના ગામમાં રહી ખેડૂતો અને ગામોના વિકાસ માટે પ્રતિબદ્ધ રહ્યા. સંદીપ અને તેજશ પટેલે પિતાની અણધારી વિદાય પછી તેમની જવાબદારી ઉઠાવી, ખેડૂતોના હિતમાં કાર્ય શરૂ કર્યું.",
          "",
          "તેજશ પટેલે ૧૯૯૯માં પેટલાદ-સોજીત્રા તાલુકા ખરીદ-વેચાણ સંઘની ચૂંટણી જીતી, સંઘના વહીવટમાં સુધારાઓ કર્યા. પેટલાદ APMCમાં ખેડૂત સહાયતા કેન્દ્ર શરૂ કર્યું અને 'અપની મંડી' કન્સેપ્ટ રજૂ કર્યો. તેઓ અમૂલ ડેરીના ડિરેક્ટર તરીકે દૂધ ઉત્પાદકોના હિતમાં કામ કરતા રહ્યા.",
          "",
          "તેજશ પટેલે ૨૦૧૮માં સૌરઊર્જા ઉત્પાદક સહકારી મંડળીની સ્થાપના કરી, જેના થકી ૩૮૮ ખેડુતો ત્રણ કરોડ યુનિટ વીજળી ઉત્પન્ન કરી. બાયોગેસ અને સેન્દ્રિય ખાતર પ્રોજેક્ટ્સ village self-reliance માટે આરંભ્યા. ઓરેન્જ ક્રાંતિ હેઠળ, સોલાર મંડળી સ્થાપન અને ૨૫ વર્ષ માટે મફત વીજળી યોજના પર કાર્ય ચાલુ છે. તેઓ ખેડુતો માટે નવી યોજનાઓ અને પ્રોજેક્ટ્સ દ્વારા કાયમી પરિવર્તન લાવવા પ્રયત્નશીલ છે.",
        ],
      },
      {
        number: "03",
        title: "મણિભાઈ પટેલે આગળ વધીને સહકારી પ્રવૃતિઓનો માર્ગ  અપનાવ્યો ",
        subtitle: "",
        description: [
          "શ્વેતક્રાંતિના પ્રેરણાસ્ત્રોત ત્રિભુવનદાસ પટેલ સાથે મળીને ગામેગામ સહકારી પ્રવૃતિઓનો પાયો નાંખવાનું કામ કર્યું. પીપળાવ ગામમાં સહકારી દૂધ મંડળી સ્થાપવા સાથે આસપાસના ગામડાઓમાં પણ સહકારી દૂધ મંડળી શરૂ કરવા માટે સહયોગ આપ્યો. પીપળાવ ગામના સરપંચ તરીકે કાર્યભાર સંભાળતા અનેકવિધ વિકાસના કામો હાથ ધર્યા. પીપળાવ ગામમાં આવેલું આશાપુરી માતાનુ મંદિર શ્રધ્ધાનું તથા આસ્થાનું કેન્દ્ર છે જયાં રાજય જ નહીં.",
          "",
          "“આશાપુરી માતાજીના દર્શનાર્થે દેશભરમાંથી શ્રધ્ધાળુઓની સુવિધા માટે પીપળાવ ગામમાં ગામમાં વર્ષ ૧૯૭૫માં અદ્યતન બસ સ્ટેશન નું નિર્માણ કરાવ્યું.”",
          "",
          "અહી દેશભરમાંથી લોકો દર્શનાર્થે આવતા. જેથી બહારગામથી આવતા દર્શનાર્થીઓઅને શ્રદ્ધાળુઓની સુવિધા માટે ગામમાં બસ સ્ટેશન બનાવવા માટે જગ્યા ફાળવી, એટલું જ નહીં. વર્ષ ૧૯૭૫માં સુવિધાયુક્ત અદ્યતન બસ સ્ટેન્ડ ઉભુ કરવામાં આવેલું જે બૃહદ ખેડા જિલ્લાનું પ્રથમ અદ્યતન બસ સ્ટેન્ડ બન્યું હતું. વર્ષ ૧૯૬૧થી ૧૯૭૫ સુધી પીપળાવ અને આસપાસના ગામડાઓમાં વિકાસ માટે અનેક કાર્યો કરીને ખેડૂતોના જીવનસ્તરને ઊંચુ લાવવાનો પ્રયાસ કર્યો.",
        ],
      },
      {
        number: "04",
        title: "સહકારી પ્રવૃતિઓના ચીંધેલા નવા રાહ પર આગળ વધતાં બિપિનભાઈ પટેલ",
        subtitle: "",
        description: [
          "બિપીનભાઈ પટેલે સરકારી તંત્ર અને વિવિધ સંસ્થાઓમાં ખેડૂતોનું પ્રતિનિધિત્વ કર્યું. પીપળાવ ગામમાં આશાપુરી માતાજીના મંદિરના વિકાસ માટે અનેક કાર્યો કર્યા અને ટ્રસ્ટી તરીકે સેવા આપી. સરપંચપદ સંભાળતા બગીચા અને ક્રીડાંગણ બનાવ્યાં. મજૂરીકામ કરતા લોકોને આવાસ માટે જમીન ફાળવી અને સરકારી યોજના હેઠળ ઘર બનાવ્યા.",
          "",
          "વિધાનસભા ચૂંટણીમાં ઇંદુભાઈ ચતુરભાઈ પટેલ સાથે ઉમેદવારી કરી. 35 વર્ષ સુધી પેટલાદ તાલુકા પંચાયત સભ્ય તરીકે સેવા આપી. પેટલાદ-સોજીત્રા તાલુકા ખરીદ-વેચાણ સંઘના ચેરમેન તરીકે ખેડૂતો માટે જરૂરી ચીજવસ્તુઓ ઉપલબ્ધ કરાવ્યું.",
          "",
          "પીપળાવ કેળવણી મંડળ અને પાટીદાર સમાજના પ્રમુખ તરીકે જીવનભર સેવા આપી. તેમના પિતા મિણભાઈ પટેલ વર્ષ 1950થી સહકારી સંસ્થાના ફાઉન્ડર ડિરેક્ટર હતા. બિપીનભાઈએ વિવિધ સંસ્થાઓમાં ખેડૂત હિત માટે જીવન સમર્પિત કર્યું અને તેઓ ખેડૂતોના સશક્તિકરણ માટે સમર્પિત નેતા રહ્યા.",
        ],
      },
      {
        number: "05",
        title: "તેજશ પટેલ અને સંદીપ પટેલની ગામડાઓને આત્મનિર્ભર બનાવવાની નેમ",
        subtitle: "",
        description: [
          "ચરોતરના પાટીદારો વિદેશમાં સુખી જીવન જીવી શકતા હોવા છતાં, તેઓ ગામના વિકાસ માટે પ્રતિબદ્ધ રહ્યા. બિપીનભાઈ પટેલના અણધાર્યા અવસાન પછી, તેમના પુત્રો સંદીપ અને તેજશ પટેલે પિતાની જેમ ખેડૂતોના હિતમાં કાર્ય કર્યું. સંદીપ પટેલ 2000માં સોજીત્રા તાલુકા પંચાયત પ્રમુખ તરીકે ચૂંટાઈ આવ્યા અને આવાસો સહિત અનેક વિકાસ પ્રોજેક્ટ હાંસલ કર્યા.",
          "",
          "તેજશ પટેલ 1999માં પેટલાદ-સોજીત્રા ખરીદ-વેચાણ સંઘના સંચાલક બન્યા અને ટેક્નોલોજીનો ઉપયોગ કરીને 8000 ચીજવસ્તુઓ સસ્તા ભાવે ખેડૂતો સુધી પહોંચાડી. APMCમાં ‘અપની મંડી’ કન્સેપ્ટ રજૂ કર્યો. તેઓ અમૂલ ડેરી અને ગુજકોમાસોલમાં પણ મહત્વના પદે રહ્યા.",
          "",
          "2018માં, તેમણે સૌરઊર્જા ઉત્પાદક સહકારી મંડળી સ્થાપી, જેના દ્વારા 388 ખેડુતોએ 3 કરોડ યુનિટ વીજળી ઉત્પન્ન કરી. તેઓ સ્વચ્છ ઉર્જા, બાયોગેસ, અને ઓરેન્જ ક્રાંતિ પ્રોજેક્ટ દ્વારા ગામડાઓને આત્મનિર્ભર બનાવી રહ્યા છે, જ્યારે સરકારની યોજનાઓ ખેડૂતો સુધી પહોંચાડવા પ્રયત્નશીલ છે.",
        ],
      },
    ],
  },
};

const Process = () => {
  const { language } = useLanguage(); // true = English, false = Gujarati
  const [homeData, setHomeData] = useState(contentData.english);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    AOS.refresh();
  }, []);

  useEffect(() => {
    setHomeData(language ? contentData.english : contentData.gujarati);
  }, [language]);

  return (
    <div className="position-relative">
      <div className="thirdProcessMain row">
        {/* Text Section */}
        <div className="textSection col-md-6 d-flex align-items-center justify-content-center">
          <div className="col-md-8 col-11 m-auto text-start">
            <p className="text-secondary">{homeData.productsTitle}</p>
            <p className="fs-1 fw-bold mb-0">{homeData.headingLine1}</p>
            <p className="fs-1 fw-bold org line-height-1 mb-4">
              {homeData.headingLine2}
            </p>
            {/* <p className="fs-5 fw-r">{homeData.description}</p>*/}

            <button class="custom-btn btnOrange">
              <span>{homeData.buttonText}</span>
            </button>
          </div>
        </div>

        {/* Slides Section */}
        <div className="slideSection col-md-6  col-12">
          <div className="slideSectionExtraSpace"></div>

          {homeData.slides.map((slide, index) => (
            <div className="d-flex gap-3 mb-4" key={index}>
              <div className="d-flex align-items-center flex-column justify-content-center">
                <p className="display-3 fw-bold org bg-white">{slide.number}</p>
                <div
                  style={{
                    width: "8px",
                    height: "100%",
                    background: "#EA5136",
                  }}
                ></div>
              </div>
              <div className="d-flex justify-content-center">
                <div className="col-md-10 mx-auto text-start">
                  <p className="fs-1 fw-bold blu">{slide.title}</p>
                  {slide.subtitle && (
                    <p className="fw-semibold fs-4 blu">{slide.subtitle}</p>
                  )}
                  {Array.isArray(slide.description) ? (
                    <p
                      className="md:fs-5 tJustify blu"
                      dangerouslySetInnerHTML={{
                        __html: slide.description.join("<br />"),
                      }}
                    />
                  ) : (
                    <p className="nd:fs-5 tJustify blu">{slide.description}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Process;
